<div class="layout-footer">
    <img [src]="'assets/layout/images/footer-' + (layoutService.config().colorScheme === 'light' ? 'ultima' : 'ultima-dark') + '.svg'" alt="ultima-footer-logo">
    <div class="flex gap-2">
        <button pButton pRipple type="button" icon="pi pi-github" class="p-button-rounded p-button-text p-button-plain"></button>
        <button pButton pRipple type="button" icon="pi pi-facebook" class="p-button-rounded p-button-text p-button-plain"></button>
        <button pButton pRipple type="button" icon="pi pi-twitter" class="p-button-rounded p-button-text p-button-plain"></button>
    </div>
</div>